import { useMemo, useState } from "react";

import { createApiClient } from "./api/client";
import { CanvaschoolShell } from "./CanvaschoolShell";
import { CanvasEditor } from "./editor/CanvasEditor";
import { CanvasEntry } from "./pages/CanvasEntry";
import { isPhone } from "./viewer/isPhone";
import { CanvasViewer } from "./viewer/CanvasViewer";

import type { CanvaschoolApi } from "./api/client";
import type { CatalogTransportFactory } from "./catalog/catalogTransport";
import type { TransportFactory } from "./editor/collaborationTransport";

export type CanvaschoolAppProps = {
  api?: CanvaschoolApi;
  createTransport?: TransportFactory;
  createCatalogTransport?: CatalogTransportFactory;
};

/** The production application: the service shell with the canvas editor (a
 * read-only frame viewer on phones). A presentation lesson shows the teacher's
 * student cards instead; a student is sent to their own slides. */
export const CanvaschoolApp = ({
  api,
  createTransport,
  createCatalogTransport,
}: CanvaschoolAppProps) => {
  const client = useMemo(() => api ?? createApiClient(), [api]);
  // Decided once: rotating a phone must not swap the viewer for the editor.
  const [phone] = useState(() => isPhone());
  return (
    <CanvaschoolShell
      api={client}
      createCatalogTransport={createCatalogTransport}
      renderEditor={(route) => (
        <CanvasEntry
          key={`${route.classId}:${route.canvasId}`}
          route={route}
          createCatalogTransport={createCatalogTransport}
        >
          {(canvas) =>
            phone ? (
              <CanvasViewer route={route} />
            ) : (
              <CanvasEditor
                route={route}
                canvas={canvas}
                createTransport={createTransport}
              />
            )
          }
        </CanvasEntry>
      )}
    />
  );
};
